import { devError } from './devLog';
import { axiosRequest } from './axiosHttp';

export const axiosDelete = (urlParameters) =>
  axiosRequest('delete', urlParameters).catch((err) => {
    devError('axiosDelete failed:', err);
  });
